import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { ModalModule } from 'ngx-bootstrap/modal';
import { AppRoutingModule } from './app.routing.module';
import { FormsModule } from '@angular/forms';
import { ProveedorModule } from './components/proveedores/proveedor.module';

import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { ProveedorDetalleComponent } from './components/admin/proveedores/proveedor-detalle/proveedor-detalle.component';
import { EmpleadosEditorComponent } from './components/admin/empleados/empleados-editor/empleados-editor.component';
import { UsuariosEditorComponent } from './components/admin/usuarios/usuarios-editor/usuarios-editor.component';
import { CambiarContrasenaComponent } from './components/admin/usuarios/cambiar-contrasena/cambiar-contrasena.component';
import { RestaurarContrasenaComponent } from './components/restaurar-contrasena/restaurar-contrasena.component';
import { CategoriasEditorComponent } from './components/admin/categorias/categorias-editor/categorias-editor.component';
import { ActividadesEditorComponent } from './components/admin/actividades/actividades-editor/actividades-editor.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ProveedorDetalleComponent,
    EmpleadosEditorComponent,
    UsuariosEditorComponent,
    CambiarContrasenaComponent,
    RestaurarContrasenaComponent,
    CategoriasEditorComponent,
    ActividadesEditorComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    AppRoutingModule,
    ModalModule.forRoot(),
    ProveedorModule,
    FormsModule,
  ],
  entryComponents: [
    ProveedorDetalleComponent,
    EmpleadosEditorComponent,
    UsuariosEditorComponent,
    CambiarContrasenaComponent,
    CategoriasEditorComponent,
    ActividadesEditorComponent
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
